@if(mode==="read"){
<ng-container *ngIf="timesheetUtilizationData?.length > 0">
  <ppl-accordion [title]="'Timesheets'" [isOpen]="true">
    <div class="table-style">
      <ppl-list-table [pageConfig]="programName" [sharedDataKey]="sharedDataKey"
        (rowDetailEvent)="rowClicked($event)" [loadPage]="false"
        [data]="timesheetUtilizationData"
        [columnsToBeHidden]="columnsToBeHidden" [disableSort]="true"
        [disableSearch]="true"
        [disableSelection]="true" [actionsToBeHidden]="actionsToBeHidden"
        [pagination]="true" [recordsPerPage]="recordsPerPage"
        [jsonList]="timesheetListConfig">
      </ppl-list-table>
    </div>
  </ppl-accordion>
</ng-container>
<ng-container *ngIf="invoiceUtilizationData?.length > 0">
  <ppl-accordion [title]="'Invoices'" [isOpen]="true">
    <div class="table-style">
      <ppl-list-table [pageConfig]="programName" [sharedDataKey]="sharedDataKey"
        (rowDetailEvent)="rowClicked($event)" [loadPage]="false"
        [data]="invoiceUtilizationData"
        [columnsToBeHidden]="columnsToBeHidden" [disableSort]="true"
        [disableSearch]="true"
        [disableSelection]="true" [actionsToBeHidden]="actionsToBeHidden"
        [pagination]="true" [recordsPerPage]="recordsPerPage"
        [jsonList]="invoiceListConfig">
      </ppl-list-table>
    </div>
  </ppl-accordion>
</ng-container>

<ng-container *ngIf="purchaseRequestUtilizationData?.length > 0">
  <ppl-accordion [title]="'Purchase Requests'" [isOpen]="true">
    <div class="table-style">
      <ppl-list-table [pageConfig]="programName" [sharedDataKey]="sharedDataKey"
        (rowDetailEvent)="rowClicked($event)" [loadPage]="false"
        [data]="purchaseRequestUtilizationData"
        [columnsToBeHidden]="columnsToBeHidden" [disableSort]="true"
        [disableSearch]="true"
        [disableSelection]="true" [actionsToBeHidden]="actionsToBeHidden"
        [pagination]="true" [recordsPerPage]="recordsPerPage"
        [jsonList]="purchaseRequestListConfig">
      </ppl-list-table>
    </div>
  </ppl-accordion>
</ng-container>
<ng-container
  *ngIf="timesheetUtilizationData?.length === 0 && invoiceUtilizationData?.length === 0 && purchaseRequestUtilizationData?.length === 0">
  <div class="alert alert-info"><strong>No Data Available</strong></div>
</ng-container>
}
